import React from 'react';
import classNames from 'classnames';

import { Image } from '../../../common/components/image/image';
import Link from '../../../common/components/link/internal-link';
import withFontClassName from '../../../common/hoc/with-font-class-name';
import styles from './banner-mobile.scss';

type BannerLink = {
  to: string;
  text?: string;
};

type Props = {
  title?: React.ReactNode;
  link: BannerLink;
  image?: React.ComponentProps<typeof Image>['image'];
  category?: React.ReactNode;
  titleFontClassName?: string;
  contentFontClassName?: string;
};

class BannerMobile extends React.Component<Props> {
  renderTitle = () => {
    const { title, link, titleFontClassName } = this.props;

    return (
      <div className={classNames(styles.titleContainer, titleFontClassName)}>
        <Link to={link.to}>
          <h1 className={classNames(styles.title, 'blog-text-color')}>{title}</h1>
        </Link>
      </div>
    );
  };

  renderImage = () => {
    const { link, image } = this.props;

    return (
      <div className={styles.imageContainer}>
        <Link className={styles.image} to={link.to}>
          <Image className={styles.imageFit} image={image} />
        </Link>
      </div>
    );
  };

  render = () => (
    <div className="blog-card-background-color">
      {this.renderImage()}
      {this.renderTitle()}
    </div>
  );
}

export default withFontClassName(BannerMobile);
